import React from "react";
import { Link } from "react-router-dom";

import "./Legal.scss";

export function PrivacyPolicy() {
  return (
    <div className="legal-component">
      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Triple P Disposal LLC</p>

        <p>
          Triple P Disposal LLC ("Triple P," "we," "us," or "our") respects your
          privacy. This Privacy Policy explains how we collect, use, and protect
          the information you provide when you request dumpster rental or trash
          removal services and when you opt in to receive text messages from us.
        </p>

        <h2>Information We Collect</h2>
        <p>
          When you place an order, we collect the information you provide,
          including your name, mobile phone number, email address, and service
          address. We use this information to schedule, deliver, and pick up your
          dumpster and to communicate with you about your order.
        </p>

        <h2>Text Messaging & Mobile Numbers</h2>
        <p>
          If you opt in to text messaging, we use your mobile phone number to
          send you messages about your order, including delivery and pickup
          scheduling updates and account notifications. Message frequency varies
          based on your order activity. Message and data rates may apply.
        </p>
        <p className="legal-emphasis">
          We do not sell, rent, share, or otherwise disclose your mobile phone
          number or SMS opt-in consent to any third parties or affiliates for
          their marketing purposes. Mobile information will not be shared with
          third parties for marketing or promotional purposes. All other
          categories of information are subject to the sharing terms described in
          this policy, but text messaging originator opt-in data and consent are
          never shared with third parties.
        </p>

        <h2>How to Opt Out</h2>
        <p>
          You can cancel text messages at any time by replying STOP to any
          message you receive from us. For help, reply HELP. You may also contact
          us directly to update your communication preferences.
        </p>

        <h2>How We Share Information</h2>
        <p>
          We may share order information with service providers who help us
          operate our business (such as payment processors and delivery
          logistics), only as needed to fulfill your order. We do not sell your
          personal information. As stated above, mobile phone numbers and SMS
          consent are never shared with third parties for marketing purposes.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact Triple
          P Disposal LLC.
        </p>

        <p className="legal-links">
          See also our{" "}
          <Link to="/terms">Terms &amp; Conditions</Link>.
        </p>
      </div>
    </div>
  );
}
